// ═══════════════════════════════════════════════════════════════
//  WORD OF MOUTH — customer quotes rotating on the homepage
//
//  TO ADD a quote:    copy a whole { ... } block, paste it, edit it
//  TO REMOVE a quote: delete its whole { ... } block
//  Tip: keep quotes to one or two sentences so they look good big
// ═══════════════════════════════════════════════════════════════

export const testimonials = [
  {
    text: "The cut lines are so sharp they look printed. Strovyn treated our 1890s villa like a gallery piece.",
    author: "Margaret H.",
    context: "Heritage restoration — North Adelaide",
  },
  {
    text: "They repainted our entire office across two weekends. Zero disruption on Monday, flawless result.",
    author: "Daniel K.",
    context: "Commercial repaint — Unley",
  },
  {
    text: "Our twenty-year-old kitchen cabinets look factory new. The spray finish is genuinely unbelievable.",
    author: "Priya S.",
    context: "Cabinet refinishing — Norwood",
  },
];
